import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OrganizationResource extends AuthenticatedResource {
  static urlRoot = '/admin/organizations'

  // The list used to be served with max-age until end of day; revalidate so
  // browsers holding such a response (and future edits) always hit the API.
  static getFetchInit(init: RequestInit): RequestInit {
    return { ...super.getFetchInit(init), cache: 'no-cache' };
  }

  readonly id: number | undefined = undefined;
  readonly title: string = '';

  pk() {
    return this.id?.toString();
  }
}